import React from 'react';
import PropTypes from 'prop-types';

import TranslationProvider from '../../providers/TranslationProvider';

import './Checkbox.scss';
import './TermsOfServiceCheckbox.scss';
import CheckboxGroup from './CheckboxGroup';
import Checkbox from './Checkbox';
import { sanitizeString } from '../../utils/sanitizeString';

const privacyPolicyLink = '<a target="_blank" rel="noopener noreferrer" href="https://resy.com/privacy">Privacy Policy</a>';
const termsOfServiceLink = '<a target="_blank" rel="noopener noreferrer" href="https://resy.com/terms">Terms of Service</a>';
const legalText = `I have read and accept the ${privacyPolicyLink} and ${termsOfServiceLink}.`;

// these rules are deprecated, address later
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
const TermsOfServiceCheckbox = ({ onChange, checked, isNonUS }) => {
  const sanitizedLegalText = sanitizeString(legalText);

  return (
    <div className={`TermsOfServiceCheckbox ${isNonUS ? 'non-us-container' : 'resy-container'}`}>
      <CheckboxGroup>
        <Checkbox
          asSwitch
          checked={checked}
          onChange={onChange}
          name="terms_of_service"
        />
        <TranslationProvider
          translationKey="terms_accept"
        >
          <label
            className="TermsOfServiceCheckbox__switch-label"
            htmlFor="terms_of_service"
            dangerouslySetInnerHTML={{ __html: sanitizedLegalText }}
          />
        </TranslationProvider>
      </CheckboxGroup>
    </div>
  );
};

TermsOfServiceCheckbox.propTypes = {
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool,
  isNonUS: PropTypes.bool,
};

TermsOfServiceCheckbox.defaultProps = {
  checked: false,
  isNonUS: false,
};

export default TermsOfServiceCheckbox;
/* eslint-enable */
